module.exports = __webpack_public_path__ + "assets/img/12f366b278d2c4094d0c80a9ad2de4fc.png";